import { useMutation } from "@tanstack/react-query";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";
//----------------------------------------------------------------

const updatePageIndicator = async (requestData) => {
	const { code, accessToken } = { ...requestData };

	try {
		const requestPayload = { checkpoint: code };
		const response = await request({
			url: "/pageIndicators",
			method: "PUT",
			data: JSON.stringify(requestPayload),
			accessToken: accessToken,
		});
		return response;
	} catch (e) {
		console.log("Error ", e);
		return null;
	}
};

export const useUpdatePageIndicator = () => {
	return useMutation({
		mutationFn: (requestData) => {
			return updatePageIndicator(requestData);
		},
		onError: (err) => {
			// Do something when an error is thrown
			console.log("Error", err);
		},
	});
};
